import type { CommentCardProps } from "./comment-card.type";

import { Card, Tooltip } from "antd";

import { getCommentDate } from "@/entities/comment";
import { CauserSubject } from "@/modules/causer-subject";
import { UserAvatar } from "@/ui/user-avatar";

import "./comment-card.style.less";

const { Meta } = Card;

const CommentCard = ({ comment }: CommentCardProps) => {
  const { dateString, dateHumanized } = getCommentDate(comment);

  return (
    <Card className="comment-card">
      <Meta
        avatar={<UserAvatar user={comment?.author} withTooltip />}
        title={
          <CauserSubject type="causer" model="user" item={comment?.author} />
        }
        description={<Tooltip title={dateString}>{dateHumanized}</Tooltip>}
        classNames={{ title: "comment-card--meta-title" }}
      />
      <div className="comment-content">{comment?.content}</div>
    </Card>
  );
};

export default CommentCard;
